import general from './general';
const translationEs = {
  ...general,
};

export default translationEs;
